export default "__VITE_ASSET__Bc3bLKcw__";